module.exports = __webpack_public_path__ + "static/hero-1f932297301840a83cad5e9a2684390c.png";